<template>
    <div>
        <main-object
            v-bind:headline="headline"
            v-bind:levels="levels"
            v-bind:priceType="priceType"
            v-bind:providerType="providerType"
            v-bind:show-filters="showFilters"
            v-bind:filter-start-end-keys="filterStartEndKeys"

            v-on:openForm="openPriceForm"
            v-on:openOtherServiceForm="openOtherServiceForm"
            v-on:deleteOtherService="openDeleteOtherService"
            @openEditTable="openEditTable"

            ref="mainObject"
        />
        <item-form ref="form" v-on:submit="handleSubmit" v-bind:provider-type="providerType"/>
        <other-form ref="other" v-on:submit="handleSubmit" v-bind:provider-type="providerType"/>
        <edit-table ref="editTable" :provider-type="providerType" v-on:submit="handleSubmit"></edit-table>

    </div>




</template>

<script>

import Mixin from '../tab';
import PriceMixin from './mixins'
import ItemForm from './Forms/Other';
import OtherForm from './Forms/OtherService';


import MainObject from "@components/CRUD/Item/Tabs/ProviderPrices/Main";
import {getOtherService} from "@api";
import {notifyError} from "@components/Notification";
import EditTable from "@components/CRUD/Item/Tabs/ProviderPrices/Forms/OtherEditTable.vue";



export default {
    mixins: [ Mixin, PriceMixin ],

    components: {EditTable, MainObject, ItemForm, OtherForm},

    data: function () {
        return {
            headline: 'Zusatzleistungen',
            levels: ['level', 'otherServiceType', 'priceGroup', 'price'],
            priceType: 'other',
            providerType: 'calculation',
            showFilters: {
                'otherServiceType.category': "",
                'timePeriods.startAt[before]': '',
                'timePeriods.endAt[after]': '',
            },
            filterStartEndKeys: ['timePeriods.endAt[after]', 'timePeriods.startAt[before]'],
            deleteOtherService: null,
        }
    },

    methods: {
        openDeleteOtherService: function (item) {
            notifyError('Löschen auf der Seite nicht möglich!')
        },

        openOtherServiceForm: function(otherService = {}) {
            if(otherService.id){
                this.isLoading = true
                getOtherService(otherService.id, '?_groups[]=agency_read&_groups[]=provider_read&_groups[]=other_service_type_read').then(response => {
                    otherService = response.data
                    this.$refs.other.setType(response.data.agency ? 'agency' : 'direct');
                    this.$refs.other.open(otherService);
                });
            } else {
                this.$refs.other.open(otherService);
            }
        },
    }


}
</script>
